import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Field } from "redux-form";
import { ReduxControls } from "rhombus-react";
import { noop } from "utils/common";

import "./EditableSelect.css";

export default function EditableSelect({ dependentValues = {} }) {
	const { id, rowIndex, disabled = false, options = [], hasError = false, placeholder } = dependentValues;
	const fieldIndex = Number.isInteger(rowIndex) ? rowIndex : id - 1;
	const selectOptions = options.map(option => ({ label: option, value: option }));
	const containerClassName = classNames("editable-select-container", { "has-error": hasError });

	const formatOptionValue = (value) => {
		if (!value) { return null; }
		return { label: value, value };
	};

	const parseOptionValue = (value) => {
		return value?.value || value;
	};

	return (
		<div className={containerClassName}>
			<Field
				component={ReduxControls.Select}
				name={`${fieldIndex}.mappingElement`}
				options={selectOptions}
				disabled={disabled}
				isClearable={false}
				placeholder={placeholder}
				format={formatOptionValue}
				parse={parseOptionValue}
				className="grid-editable-select"
				menuPortalTarget={document.body}
				menuPosition="fixed"
				onMenuScrollToBottom={noop}
				onKeyDown={e => e.stopPropagation() }
			/>
		</div>
	);
}

EditableSelect.displayName = "EditableSelect";

EditableSelect.propTypes = {
	dependentValues: PropTypes.shape({
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		rowIndex: PropTypes.number,
		disabled: PropTypes.bool,
		options: PropTypes.arrayOf(PropTypes.string),
		hasError: PropTypes.bool,
		placeholder: PropTypes.string,
	}),
};

